import $ from "jquery";

export default class CommentForm {
    constructor(isAjax = false) {
        this.form = document.getElementById("commentform");
        this.noticesWrapper = document.querySelector(".jsPageNoticeWrapper");

        if (this.form) {
            this.events();
        }
    }

    events() {
        this.validator = $(this.form).validate({
            rules: {
                author: "required",
                email: {
                    required: true,
                    email: true,
                },
                comment: "required",
                honeypot: {
                    maxlength: 0,
                },
            },
            messages: {
                author: "Pole Imię jest obowiązkowe!",
                email: {
                    required: "Pole E-mail jest obowiązkowe!",
                    email: "Podaj poprawny adres e-mail!",
                },
                comment: "Pole Komentarz jest obowiązkowe!",
            },
        });
    }

    hideNotice() {
        const self = this;

        if (document.location.hash) {
            window.scrollTo(window.scrollX, window.scrollY - 100);
        }
        
        window.setTimeout(() => {
            self.noticesWrapper.classList.add("is-hidden");
        }, 10000);
    }
}
